import ConfigNovaSlaComOrigemSchema from '@/schema/ConfigNovaSlaComOrigem.schema'
import ConfigNovaSla from '@/model/resource/ConfigNovaSla'

export default class ConfigNovaSlaComOrigem extends ConfigNovaSla {
  get $schema() {
    return ConfigNovaSlaComOrigemSchema(this)
  }
}
